import React, { useState } from "react";
import styles from "./../../sass/landing/about.module.scss";
import classNames from "classnames";
import mockup1 from "./../../Landing/assets/mockup1.png"
import { Button } from "@mui/material";
import {FileDocument} from "mdi-material-ui"
import SubscribeModal from "./SubscribeModal";

const About = () => {

  // eslint-disable-next-line no-undef
  const [open, setOpen] = useState(false);
  const handleInvestPaywall = () => {
    const isSubbed = localStorage.getItem("subbed");
    if(isSubbed) {
      window.open("https://uploads-ssl.webflow.com/6380de147e60d61383aa4d66/64792252665670484b6e49f8_DECKV2_Jun-1-2023.pdf");
    } else {
      setOpen(true);
    }
  }

  return (
    <div className={classNames(styles["about-wrapper"])}>
      <div className={classNames(styles["about"], "container")}>
        <div className="row align-items-center">
          <div className="col-md-6 col-12">
            <h3>
              <span>About</span>
              Building the Fight Against Climate Change
            </h3>
            <p>
              The majority of our global economy works based on the generation of energy by burning fossil and non-renewable fuels. This has put us in the situation we face today - environmental devastation, rising global temperatures and ultimately a future under threat.
            </p>
            <h3 className="mt-5">
              The Bluesphere Carbon Exchange
            </h3>
            <p>
              The Bluesphere Carbon Exchange allows anyone - businesses, carbon credit suppliers, and investors - to buy, hold, and sell carbon credits. It was founded on the belief that the best way to continue building the fight against climate change is to gain larger interest through investment opportunities with a simple to use platform and well vetted carbon projects.
            </p>
            <Button
              //component={MuiLink}
              onClick={() => handleInvestPaywall()}
              //href="/BlueSphereCarbon_Deck.pdf"
              //target="_blank"
              size="large"
              variant="contained"
              startIcon={<FileDocument/>}
            >
              Investor Deck
            </Button>
          </div>
          <div className="col-md-6 col-12 text-center">
            <img src={mockup1} className="img-fluid" alt="Mockup"/>
          </div>
        </div>
        <SubscribeModal
          isOpened={open}
          closeModal={() => setOpen(false)}
          successUrl="https://uploads-ssl.webflow.com/6380de147e60d61383aa4d66/64792252665670484b6e49f8_DECKV2_Jun-1-2023.pdf"
          submitButtonLabel="View Investor Deck"
        />
      </div>
    </div>
  );
};

export default About;
